import React from 'react';
import PropTypes from 'prop-types';

const TrashIcon = ({ onClick }) => (
    <svg className="svg-icon trash-icon" width="20px" height="20px" viewBox="10 10 20 20"
        xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={onClick}>
        <g className="grey-path" fillRule="evenodd" transform="translate(0.000000, 0.000000)">
            <path d="M25.8672178,14 L29,14 C29.5522847,14 30,14.4477153 30,15 C30,15.5522847 29.5522847,16 29,
            16 L27.8674268,16 C27.8673239,16.0819072 27.8621936,16.1647093 27.8517735,16.2480695 L26.3517735,
            28.2480695 C26.2266663,29.2489271 25.3758643,30 24.3672178,30 L15.6327822,30 C14.6241357,30 13.7733337,
            29.2489271 13.6482265,28.2480695 L12.1482265,16.2480695 C12.1379403,16.1657798 12.1327822,
            16.08293 12.1327822,16 L11,16 C10.4477153,16 10,15.5522847 10,15 C10,14.4477153 10.4477153,14 11,
            14 L14.1327822,14 L14.3414114,14 C15.1650842,11.6696153 17.3875623,10 20,10 C22.6124377,10 24.8349158,
            11.6696153 25.6585886,14 L25.8672178,14 Z M16.5351288,14 L23.4648712,14 C22.7732524,12.8043973 21.4805647,
            12 20,12 C18.5194353,12 17.2267476,12.8043973 16.5351288,14 Z M14.1327822,16 L15.6327822,28 L24.3672178,
            28 L25.8672178,16 L14.1327822,16 Z M16,18 L18,18 L19,26 L17,26 L16,18 Z M22,18 L24,18 L23,26 L21,26 L22,
            18 Z">
            </path>
        </g>
    </svg>
);

TrashIcon.propTypes = {
  onClick: PropTypes.func,
};

TrashIcon.defaultProps = {
  onClick() {},
};

export default TrashIcon;
